import { ChangeDetectionStrategy, Component, input, InputSignal } from "@angular/core";

@Component({
  selector: "app-page-header",
  templateUrl: "./page-header.component.html",
  styleUrl: "./page-header.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  public readonly heading: InputSignal<string> = input.required<string>();
  public readonly direction: InputSignal<"row" | "column" | "row-reverse" | "column-reverse"> =
    input<"row" | "column" | "row-reverse" | "column-reverse">("row");
  public readonly justify: InputSignal<"start" | "center" | "space-between"> = input<
    "start" | "center" | "space-between"
  >("space-between");
}
